<template>
  <div>
    <div class="OrderinforForm">
      <!--头部标签-->
      <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
        <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
          系统通知详情
        </span>
        <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
          <a href="javascript:;" @click="closeInformation()">
            <i class="el-icon-close"></i>
          </a>
        </span>
      </div>
      <!--主体结构-->
      <div class="playlistbox_botton">
        <div style="width: 860px;margin: 0 auto;overflow: hidden;text-align: center;font-size: 20px;margin-top: 10px;">
          {{data.title}}
        </div>
        <div style="width: 860px;margin: 0 auto;overflow: hidden;text-align: center;">
          <hr>
        </div>
        <div style="width: 860px;margin: 0 auto;overflow: hidden;text-align: center;">
          <table width="100%">
            <tr>
              <td width="32%">发送人：{{data.admin_name}}</td>
              <td width="36%"></td>
              <td width="32%">时间：{{data.time*1 | formatDate}}</td>
            </tr>
          </table>
        </div>
        <div style="width: 860px;margin: 0 auto;overflow: hidden;text-align: center;">
          <hr>
        </div>
        <div style="width: 860px;margin: 0 auto;overflow: hidden;">
          <mavon-editor :defaultOpen = "'preview'" :ishljs="true" :toolbarsFlag='false' :zIndex="0" :subfield="false" ref=md :value="data.content"></mavon-editor>
        </div>
        <div style="width: 860px;margin: 0 auto;overflow: hidden;text-align: center;">
          <div v-if="data.noticeList==''">
            <el-divider></el-divider>
            <span style="color: #94938a;">
              没有附件
            </span>
            <el-divider></el-divider>
          </div>
          <div v-else>
            <el-table :data="data.noticeList" stripe style="width: 100%">
              <el-table-column prop="name">
                <template slot-scope="scope">
                  <div class="flex">
                    <img :src="witch_img(scope.row.name)" alt="" width="35px">
                    <span style="margin-left: 5px;" v-if="img_look(scope.row.name)">
                      <a :href="'/api'+scope.row.url" target="_blank" style="color: #000000;">
                        {{scope.row.name}}
                      </a>
                    </span>
                    <span style="margin-left: 5px;" v-else>
                      {{scope.row.name}}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="address" width="80">
                <template slot-scope="scope">
                  <el-button size="small" @click="downloadF(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    props: {
        data_id: {
          type: String,
          default: ''
        },
        div_name: {
          type: String,
          default: ''
        }
      },
    data() {
      return {
        data:'',
      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
          }
        },

    created() {
      //this.getData();
    },
    //页面开启时执行
    mounted(){
      //
    },

    watch: {
      'data_id': {
        handler(){
          //console.log(this.data_id);
          let getdata="";
          getdata=sessionStorage.getItem("notice_infor_data");
          if (this.data_id == ""||getdata==null||getdata==""||getdata=="null") {
            return false;
          }
          getdata=JSON.parse(getdata);
          //console.log(getdata);
          this.data=getdata;
          let dobj=document.getElementById("aboutHtml_notice");
          dobj.innerHTML = this.data.content;
        }
      }
    },

    methods: {
      //如果是图片文件可以预览
      img_look(name){
        let data=name.split(".");
        let file_type=data[data.length-1];
        let img="";
        switch(file_type){
          case "jpg"://普通登录验证
          img="img";
          break;
          case "png"://普通登录验证
          img="img";
          break;
          default:
          img="noimg";
        }
        if(img=="img"){
          return true;
        }else{
          return false;
        }
      },
      //图片选择
      witch_img(name){
        let data=name.split(".");
        let file_type=data[data.length-1];
        let img="";
        //console.log(file_type);
        switch(file_type){
          case "pdf"://普通登录验证
          img="/api/imgs/files_img/pdf.png";
          break;
          case "jpg"://普通登录验证
          img="/api/imgs/files_img/photo_img.png";
          break;
          case "png"://普通登录验证
          img="/api/imgs/files_img/photo_img.png";
          break;
          case "doc"://普通登录验证
          img="/api/imgs/files_img/word.png";
          break;
          case "docx"://普通登录验证
          img="/api/imgs/files_img/word.png";
          break;
          case "xls"://普通登录验证
          img="/api/imgs/files_img/xls.png";
          break;
          case "xlsx"://普通登录验证
          img="/api/imgs/files_img/xls.png";
          break;
          case "ppt"://普通登录验证
          img="/api/imgs/files_img/ppt.png";
          break;
          case "pptx"://普通登录验证
          img="/api/imgs/files_img/ppt.png";
          break;
          case "txt"://普通登录验证
          img="/api/imgs/files_img/txt.png";
          break;
          case "rar"://普通登录验证
          img="/api/imgs/files_img/yasuo.png";
          break;
          case "zip"://普通登录验证
          img="/api/imgs/files_img/yasuo.png";
          break;
          default:
          img="/api/imgs/files_img/unknown.png";
        }
        return img;
      },
      //文件下载
      downloadF(item){
        const link = document.createElement('a')
        let name=item.name;
              link.setAttribute("download", name) //下载的文件名
              link.href = "/api"+item.url   //文件url
              link.click()
      },
      //！！！！
      //打开通知详情
      /**
      openInformation(){
        this.data=this.datas;
        let dobj=document.getElementById("aboutHtml_2");
        dobj.innerHTML = this.data.content;
        document.getElementById('Noticeinformain_2').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      */
      closeInformation(){
        /**
        this.data='';
        let dobj=document.getElementById("aboutHtml_2");
        dobj.innerHTML = '';
        */
        document.getElementById(this.div_name).style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
   .flex{
     /*flex 布局*/
     display: flex;
     /*实现垂直居中*/
     align-items: center;
     /*实现水平居中*/
   }
</style>



// WEBPACK FOOTER //
// src/admin/views/A_zujian/web_notice.vue